import React from 'react';

function EmptyState({ icon: Icon = null, title, hint = null, action = null }) {
  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 14,
      textAlign: 'center',
      padding: '48px 24px',
      width: '100%'
    },
    icon: {
      display: 'flex',
      padding: 18,
      borderRadius: 16,
      border: '1px solid var(--border-ops)',
      background: 'var(--surface-raised)',
      color: 'var(--text-secondary-ops)',
      lineHeight: 0
    },
    title: {
      margin: 0,
      color: 'var(--text-primary-ops)',
      fontSize: 15,
      fontWeight: 600,
      letterSpacing: '0.01em'
    },
    hint: {
      margin: 0,
      maxWidth: 380,
      color: 'var(--text-secondary-ops)',
      fontSize: 12,
      lineHeight: 1.55
    },
    action: {
      marginTop: 6
    }
  };

  return (
    <div style={styles.container}>
      {Icon ? (
        <div style={styles.icon}>
          <Icon size={26} />
        </div>
      ) : null}
      <h3 style={styles.title}>{title}</h3>
      {hint ? <p style={styles.hint}>{hint}</p> : null}
      {action ? <div style={styles.action}>{action}</div> : null}
    </div>
  );
}

export default EmptyState;
